module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('section', {
    staticClass: "mobile"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "masthead-logo-mobile mobile"
  }, [_c('img', {
    attrs: {
      "src": 'static/img/common/logo.png'
    }
  })])])])])]), _vm._v(" "), _c('mast-head', {
    attrs: {
      "page": "home"
    }
  }), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row intro-box"
  }, [_c('div', {
    staticClass: "col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center"
  }, [_c('h3', {
    staticClass: "h3-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.home.subtitle)
    }
  })])])])]), _vm._v(" "), _c('section', [_c('my-carousel', {
    attrs: {
      "array": 'home_array'
    }
  })], 1), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.home.about)
    }
  }), _vm._v(" "), _vm._l((_vm.home.about_body), function(p, index) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('router-link', {
    staticClass: "router-link-container",
    attrs: {
      "to": "/about"
    }
  }, [_c('link-button', {
    attrs: {
      "label": _vm.home.link_button
    }
  })], 1)], 1)], 2)])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-md-offset-1 paragraph-left"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.home.food)
    }
  }), _vm._v(" "), _vm._l((_vm.home.food_body), function(p, index) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  }), _vm._v(" "), _c('router-link', {
    staticClass: "router-link-container",
    attrs: {
      "to": "/food"
    }
  }, [_c('link-button', {
    attrs: {
      "label": _vm.home.link_button
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-8 box-shadow-container"
  }, [_c('image-loader', {
    staticClass: "image-loader-container",
    attrs: {
      "imgSrc": 'home/' + _vm.home.food_image
    }
  })], 1)])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-md-offset-1 paragraph-left mobile"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.home.projects)
    }
  }), _vm._v(" "), _vm._l((_vm.home.projects_body), function(p, index) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  }), _vm._v(" "), _c('router-link', {
    staticClass: "router-link-container",
    attrs: {
      "to": "/projects"
    }
  }, [_c('link-button', {
    attrs: {
      "label": _vm.home.link_button
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-8 col-md-offset-1 box-shadow-container"
  }, [_c('image-loader', {
    staticClass: "image-loader-container",
    attrs: {
      "imgSrc": 'home/' + _vm.home.projects_image
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 paragraph-right desktop"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.home.projects)
    }
  }), _vm._v(" "), _vm._l((_vm.home.projects_body), function(p, index) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  }), _vm._v(" "), _c('router-link', {
    staticClass: "router-link-container",
    attrs: {
      "to": "/projects"
    }
  }, [_c('link-button', {
    attrs: {
      "label": _vm.home.link_button
    }
  })], 1)], 2)])])]), _vm._v(" "), _c('section', {
    staticClass: "pure-text-centered",
    attrs: {
      "id": "clients"
    }
  }, [_c('client-section')], 1), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
    staticClass: "section-joined-bottom"
  }, [_c('text-ticker', {
    attrs: {
      "page": "home"
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "section-joined-top"
  }, [_c('footer-image')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9163cdfe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home.vue
// module id = 154
// module chunks = 2